import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { User } from 'shared-lib';
import { UserService } from 'shared-lib';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assign-task-modal',
  templateUrl: './assign-task-modal.component.html',
  styleUrl: './assign-task-modal.component.scss',
  standalone: false,
})
export class AssignTaskModalComponent {
  @ViewChild('closeModal') closeModal!: ElementRef;
  @Input() areaId?: number;
  @Output() idSelected = new EventEmitter<number>();
  @Input() assignTask!: () => void;
  title?: string;

  submitText?: string;

  filterText: string = '';
  isDropdownOpened: boolean = false;
  mobileUsers: User[] = [];
  constructor(
    private userService: UserService,
    private toastr: ToastrService
  ) {}
  selectFieldAgent(event: MouseEvent, id: number) {
    event.stopPropagation();
    this.isDropdownOpened = false;
    this.idSelected.emit(id);
    var mobUser = this.mobileUsers!.find((x) => x.id == id);
    this.filterText = mobUser!.fullName;
  }

  onFilterChange() {
    this.filterMobileUsers(this.filterText);
  }

  openDropdown() {
    this.isDropdownOpened = this.mobileUsers.length > 0;
  }

  filterMobileUsers(filterText: string) {
    this.isDropdownOpened = true;
    this.getMobileUsers(filterText);
  }

  getMobileUsers(filterText: string = '') {
    this.userService.getMobileUsers(this.areaId!, filterText).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.mobileUsers = responseData.data;
          if (this.mobileUsers.length == 0) {
            this.isDropdownOpened = false;
          } else if (filterText) {
            this.isDropdownOpened = true;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
}
